import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SurveyState } from '..';

export const selectSurveySlice = createFeatureSelector<SurveyState>('survey');

export const getActiveSurveyInfo = createSelector(
  selectSurveySlice,
  (state: SurveyState) => state.survey?.find(survey => survey.isActive) // returns the first active survey
);
